import { Box, Grid, Tab, Tabs, useTheme } from "@mui/material";
import IconConstants from "../../utils/IconConstants";
import CustomerInfo from "../../components/support/CustomerInfo";
import { useState } from "react";
import PropTypes from "prop-types";
import EmailList from "../../components/support/email";
import WhatsAppWeb from "../../components/support/WhatsappSupport";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: "1% 0" }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const tableColumns = [
  {
    icon: "SupportWhatsApp",
    width: { md: "2.83vw" },
    height: { md: "2.37vw" },
    component: <WhatsAppWeb />,
  },
  {
    icon: "SupportCall",
    width: { md: "2.83vw" },
    height: { md: "2.37vw" },
    component: <></>,
  },
  {
    icon: "SupportGuest",
    width: { md: "2.83vw" },
    height: { md: "2.37vw" },
    component: <></>,
  },
  {
    icon: "SupportEmail",
    width: { md: "2.83vw" },
    height: { md: "2.37vw" },
    component: <EmailList />,
  },
];

const CustomerSupport = () => {
  const { palette } =  useTheme();
  const [openCustInfo, setOpenCustInfo] = useState(false);
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // const cards = [
  //   {
  //     label: "Immediate Action Required",
  //     value: 45,
  //     icon: IconConstants.ActionRequired,
  //     width: { md: "2.83vw" },
  //     height: { md: "2.37vw" },
  //   },
  //   {
  //     label: "Tickets resolved",
  //     value: 33,
  //     icon: IconConstants.Tick,
  //     width: { md: "3.56vw" },
  //     height: { md: "2.89vw" },
  //   },
  //   {
  //     label: "Pending tickets",
  //     value: 23,
  //     icon: IconConstants.Pending,
  //     width: { md: "2.7vw" },
  //     height: { md: "2.7vw" },
  //   },
  // ];

  return (
    <>
      <Grid
        container
        gap={"2vw"}
        justifyContent={"center"}
        sx={{ overflow: "auto" }}
      >
        {/* <Grid item xs={11.55}>
          <Box
            sx={{
              backgroundBlendMode: "darken",
            }}
          >
            <Box sx={{ m: "1%" }}>
              <Typography
                sx={{
                  color: " #252525",
                  fontSize: { md: "2.21vw" },
                  fontWeight: 700,
                }}
              >
                Customer Support
              </Typography>
            </Box>
            <Grid container gap={"0.8vw"}>
              {cards.map((card, cardInd) => (
                <Grid
                  item
                  key={card.value}
                  // xs={2.82}
                  sx={{
                    width: { md: "16.83vw" },
                    height: { md: "6.63vw" },
                    padding: "0 1.5%",
                    boxShadow: "0px 0px 15px 0px #0000001A",
                    borderRadius: "20px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    background: "#FFFFFF",
                    transition:
                      "transform 0.4s ease-in-out, box-shadow 0.4s ease-in-out",
                    perspective: "1000px",
                    transformStyle: "preserve-3d",
                    "&:hover": {
                      transform: "translateY(-10px) rotateX(10deg)",
                      boxShadow: "0 20px 30px rgba(0, 0, 0, 0.4)",
                    },
                    cursor: "pointer",
                  }}
                >
                  <Box sx={{ width: "70%" }}>
                    <Typography
                      sx={{
                        color: "#09121E",
                        fontSize: { md: "2.15vw" },
                        fontWeight: 700,
                      }}
                    >
                      {card.value}
                    </Typography>
                    <Typography
                      sx={{
                        color: "#667185",
                        fontSize: { md: "0.74vw" },
                        fontWeight: 500,
                      }}
                    >
                      {card.label}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      width: "30%",
                      textAlign: "right",
                    }}
                  >
                    <Box
                      sx={{
                        width: card.width,
                        height: card.height,
                        ml: "auto",
                      }}
                    >
                      <img
                        src={card.icon}
                        style={{ width: "100%", height: "100%" }}
                      />
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Grid> */}

        <Grid item xs={11.55} sx={{ mt: "1%", height: "100dvh" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="support-channels"
            sx={{
              background: palette.tab.gradient,
            }}
          >
            {tableColumns.map((column, index) => (
              <Tab
                sx={{
                  borderBottom: index === value ? "5px solid red" : "none",
                }}
                key={column.icon}
                icon={
                  <Box sx={{ width: column.width, height: column.height }}>
                    <img
                      alt={column.icon}
                      src={IconConstants[column.icon]}
                      style={{
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  </Box>
                }
                {...a11yProps(index)}
              />
            ))}
          </Tabs>

          {tableColumns.map((column, index) => (
            <CustomTabPanel key={column.icon} value={value} index={index}>
              <Box sx={{ height: 1 }}>{column?.component}</Box>
            </CustomTabPanel>
          ))}
        </Grid>
      </Grid>

      <CustomerInfo open={openCustInfo} setOpen={setOpenCustInfo} />
    </>
  );
};

export default CustomerSupport;
